<template>
  <a-modal
    :visible="showModalEditUser || showModalDelUser || showModalHistoryUser || showModalChangePassword || showModalSuccesChangePass"
    :footer="null"
    :closable="!showModalSuccesChangePass"
    :width="490"
    @cancel="$emit('handleShowModal','close',false), loading = false"
  >
    <a-row>
      <a-col class="d-flex justify-content-center">
        <div
          v-if="showModalDelUser || showModalSuccesChangePass"
          style="
              width: 180px;
              height: 180px;
              background: linear-gradient(153.43deg, #F49685 0%, #EC4426 83.33%);
              border-radius: 50%;
              margin-bottom: 40px"
        >
          <TrashIcon v-if="showModalDelUser" style="width: 180px; height:auto; color: #ffffff" />
          <Checklist v-if="showModalSuccesChangePass" style="width: 180px; height:auto; color: #ffffff; position: absolute; top: 41px; right: 112px;" />
        </div>
      </a-col>
      <a-col :span="24" class="d-flex justify-content-center">
        <div class="pbz-font subtitle-md-medium">
          {{ captionTitle() }}
        </div>
      </a-col>
      <a-col :span="24" class="d-flex justify-content-center" style="margin: 10px 0px">
        <div class="pbz-font" style="width: 60%; text-align:center; color:#999999">
          {{ captionModal() }}
        </div>
        <div v-if="showModalHistoryUser" class="col-12" style="width: 370px; height: 370px; overflow: auto">
          <ul v-for="(item, index) in dataHistory" :key="index">
            <li>{{ $moment(item.created_at).format('DD MMM YYYY HH:MM') }}</li>
            <span> {{ item.event }} </span>
            <p> {{ item.description }} </p>
          </ul>
        </div>
      </a-col>
      <a-col v-if="showModalEditUser || showModalDelUser || showModalEditUser || showModalChangePassword || showModalSuccesChangePass" :span="24" class="d-flex justify-content-center" style="margin-top: 50px">
        <a-button
          class="pbz-font"
          style="
                border: 1px solid #E00000;
                background: #E00000;
                color: #FFFFFF;
                width: 100%;
                height: auto;
                padding: .75rem;
                border-radius: 5px;
                cursor: pointer;
            "
          :disabled="isLoading"
          @click.prevent="submitButton()"
        >
          <div v-if="!loading || showModalSuccesChangePass">
            {{ captionSubmit() }}
          </div>
          <div v-if="loading && !showModalSuccesChangePass">
            <a-icon type="loading" />
          </div>
        </a-button>
      </a-col>
      <a-col v-if="showModalEditUser || showModalDelUser || showModalChangePassword" :span="24" class="d-flex justify-content-center align-items-center">
        <a-button
          class="pbz-font"
          style="
              color: #E00000;
              padding: .75rem;
              cursor: pointer;
              width: 100%;
              height: auto;
              border: none;
            "
          :disabled="isLoading"
          @click="() => {$emit('handleShowModal','close',false), loading = false}"
        >
          {{ $t('userManage.cancel') }}
        </a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import TrashIcon from '@/components/Icons/TrashIcon.vue'
import Checklist from '@/components/Icons/Checklist.vue'

export default {
  name: 'ModalUser',
  components: {
    TrashIcon,
    Checklist,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: () => false,
    },
    showModalEditUser: {
      type: Boolean,
      default: () => false,
    },
    showModalDelUser: {
      type: Boolean,
      default: () => false,
    },
    showModalHistoryUser: {
      type: Boolean,
      default: () => false,
    },
    showModalChangePassword: {
      type: Boolean,
      default: () => false,
    },
    showModalSuccesChangePass: {
      type: Boolean,
      default: () => false,
    },
    dataHistory: {
      type: Array,
    },
  },
  data: function () {
    return {
      loading: false,
    }
  },
  watch: {
    showModalEditUser: {
      deep: true,
      immediate: true,
      handler: function (value) {
        if (value === false) {
          this.loading = false
        }
      },
    },
  },
  methods: {
    captionModal() {
      if (this.showModalEditUser) {
        return this.$t('userManage.confirm_msg_edit')
      }
      if (this.showModalChangePassword) {
        return this.$t('userManage.change_password_msg')
      }
      if (this.showModalDelUser) {
        return this.$t('userManage.confirm_msg_delete')
      }
      if (this.showModalSuccesChangePass) {
        return this.$t('userManage.password_changed_msg')
      }
    },
    captionTitle() {
      if (this.showModalEditUser || this.showModalChangePassword) {
        return this.$t('userManage.confirm_title')
      }
      if (this.showModalDelUser) {
        return this.$t('userManage.confirm_delete_title')
      }
      if (this.showModalHistoryUser) {
        return this.$t('userManage.history_title')
      }
      if (this.showModalSuccesChangePass) {
        return this.$t('userManage.success_title')
      }
    },
    captionSubmit() {
      if (this.showModalEditUser) {
        return this.$t('userManage.submit_edit')
      }
      if (this.showModalDelUser) {
        return this.$t('userManage.submit_delete')
      }
      if (this.showModalChangePassword) {
        return this.$t('userManage.submit_change_password')
      }
      if (this.showModalSuccesChangePass) {
        return this.$t('userManage.back_to_dashboard')
      }
    },
    submitButton() {
      this.loading = true
      if (this.showModalEditUser) {
        this.$emit('submitEditUser')
      } else if (this.showModalDelUser) {
        this.$emit('submitDeleteUser')
      } else if (this.showModalChangePassword) {
        this.$emit('submitButton')
        this.loading = false
      } else if (this.showModalSuccesChangePass) {
        this.$router.push({
          name: 'dashboard',
        })
      }
    },
  },
}
</script>

<style>

</style>
